<!-- Section 7: Hero Section (top) -->
<section class="hero-transactional">
  <div class="hero-img-block p-3 ms-1">
    <img
      src="assets/images/transactionalemail/transactional.jpeg"
      alt="Transactional Email Illustration"
      loading="lazy"
    />
  </div>
  <div class="hero-text-block">
    <h1 class="main-title">
      Deliver Trusted Transactional Emails Seamlessly with Reliability
    </h1>
    <div class="subtitle me-lg-5 pe-lg-4 px-2">
      MALtech delivers fast, secure transactional emails like order
      confirmations, OTPs, and alerts with a flexible platform that grows with
      your business. Their tailored APIs and instant analytics help optimize
      email performance. Plus, a team of expert support is always available to
      assist you.
    </div>
    <div class="hero-actions">
      <button class="hero-btn" (click)="scrollToPlans()">Explore Plans</button>
      <a class="hero-btn primary" routerLink="/sign-up" aria-label="Sign Up" [attr.href]="'/sign-up'">Sign Up</a>
    </div>
  </div>
</section>

<!--Why maltech-->
<!-- Why Choose MALtech -->
<section class="why-choose container">
  <h2 class="text-center text-logo-color mb-5">
    Why Choose MALtech for Transactional Emails?
  </h2>

  <div
    *ngFor="let feature of features; let i = index"
    class="row align-items-center mb-5"
  >

    <!-- EVEN INDEX -->
    <ng-container *ngIf="i % 2 === 0; else oddLayout">
      <!-- Text -->
      <div class="col-md-6 feature-text">
        <h3 class="text-logo-color">{{ feature.title }}</h3>
        <p>{{ feature.description }}</p>
      </div>

      <!-- Image -->
      <div class="col-md-6 feature-image">
        <img
          [src]="feature.image"
          alt="{{ feature.title }}"
          class="feature-img img-fluid rounded shadow"
          loading="lazy"
        />
      </div>
    </ng-container>

    <!-- ODD INDEX -->
    <ng-template #oddLayout>
      <!-- Image -->
      <div class="col-md-6 feature-image order-md-1 order-2">
        <img
          [src]="feature.image"
          alt="{{ feature.title }}"
          class="feature-img img-fluid rounded shadow"
          loading="lazy"
        />
      </div>

      <!-- Text -->
      <div class="col-md-6 feature-text order-md-2 order-1">
        <h3 class="text-logo-color">{{ feature.title }}</h3>
        <p>{{ feature.description }}</p>
      </div>
    </ng-template>

  </div>
</section>


<!-- Section 1: Why MALtech for Transactional Emails? -->
<section class="transactional-section">
  <div class="container">
    <h2 class="main-title">Why MALtech for Transactional Emails?</h2>
    <div class="subtitle px-2">
      At MALtech, we ensure your transactional emails  from order confirmations
      and password resets to alerts and OTPs  are delivered instantly,
      securely, and directly to the inbox. With enterprise-grade infrastructure,
      optimized deliverability, and real-time monitoring, we help businesses
      build trust with customers through reliable email communication at scale.
    </div>

    <div class="feature-grid">
      <div class="feature-card">
        <i class="bi bi-envelope-check card-icon"></i>
        <h5>High Deliverability</h5>
        <p>
          Ensure your emails reach the inbox with our robust infrastructure and
          reputation management.
        </p>
      </div>

      <div class="feature-card">
        <i class="bi bi-lightning-charge card-icon"></i>
        <h5>Fast Email Dispatch</h5>
        <p>
          Send emails within seconds, providing instant updates and
          confirmations to your users.
        </p>
      </div>

      <div class="feature-card">
        <i class="bi bi-shield-lock card-icon"></i>
        <h5>Security &amp; Compliance</h5>
        <p>
          Protect sensitive information and comply with regulations like GDPR
          with TLS, DKIM, and SPF.
        </p>
      </div>

      <div class="feature-card">
        <i class="bi bi-cloud-arrow-up card-icon"></i>
        <h5>Scalable Infrastructure</h5>
        <p>
          Whether you send 1,000 or 1 million emails a day, our cloud-native
          system scales seamlessly.
        </p>
      </div>

      <div class="feature-card">
        <i class="bi bi-bar-chart-line card-icon"></i>
        <h5>Real-time Analytics</h5>
        <p>
          Track email performance with delivery rates, opens, and clicks
          dashboards.
        </p>
      </div>

      <div class="feature-card">
        <i class="bi bi-headset card-icon"></i>
        <h5>24/7 Support &amp; Expertise</h5>
        <p>
          Our dedicated support team ensures your transactional email systems
          are always running smoothly.
        </p>
      </div>
    </div>
  </div>
</section>

<!-- Section 2: Industries We Serve -->
<section class="industries-section">
  <div class="container">
    <h2 class="main-title">Industries We Serve</h2>
    <div class="subtitle px-2">
      At MALtech, we ensure your transactional emails  from order confirmations
      and password resets to alerts and OTPs  are delivered instantly,
      securely, and directly to the inbox. With enterprise-grade infrastructure,
      optimized deliverability, and real-time monitoring, we help businesses
      build trust with customers through reliable email communication at scale.
    </div>

    <div class="industry-grid">
      <div class="industry-card">
        <div class="icon-wrap">
          <i class="bi bi-bag-check-fill"></i>
        </div>
        <h5>E-Commerce</h5>
        <p>
          Send order confirmations, shipping updates, and refund notifications,
          keeping customers informed at every stage of their shopping journey.
        </p>
      </div>

      <div class="industry-card">
        <div class="icon-wrap">
          <i class="bi bi-bank2"></i>
        </div>
        <h5>Banking &amp; Finance</h5>
        <p>
          Deliver secure OTPs, instant transaction alerts, and fraud detection
          messages, ensuring customer safety and trust.
        </p>
      </div>

      <div class="industry-card">
        <div class="icon-wrap">
          <i class="bi bi-truck"></i>
        </div>
        <h5>Logistics &amp; Transportation</h5>
        <p>
          Provide delivery confirmations, live route updates, and shipment
          tracking alerts, ensuring transparency and smooth operations.
        </p>
      </div>
    </div>
  </div>
</section>

<!-- Section 3: Email Plans -->
<!-- Section 3: Email Plans -->
<section id="email-plans" class="plan-section py-5">
  <div class="container text-center px-lg-2">
    <h2 class="main-title mb-3">Flexible Email Plans Powered by MALtech</h2>
    <p class="subtitle mb-4">
      Built on a high-performance cloud platform for dependable transactional
      email.
    </p>

    <!-- Currency Tabs -->
    <div class="currency-tabs mb-4">
      <button [class.active]="currency === 'USD'" (click)="setCurrency('USD')">
        $ USD
      </button>
      <button [class.active]="currency === 'INR'" (click)="setCurrency('INR')">
        ₹ INR
      </button>
    </div>

    <!-- Plan Grid -->
    <div class="row g-4 justify-content-center">
      <!-- Starter -->
      <div class="col-md-4 col-sm-6">
        <div class="plan-card starter h-100">
          <div class="plan-title">Starter</div>
          <p class="plan-desc">
            Perfect for small teams sending up to 100,000 emails per month,
            exclusive of GST.
          </p>
          <div class="plan-price">
            {{ getPlanPrice("starter", starterSelectedVolume) }}
          </div>
          <div class="custom-select-wrapper position-relative">
            <select
              [(ngModel)]="starterSelectedVolume"
              class="form-select plan-dropdown"
              (click)="toggleSelect()"
              (blur)="isSelectOpen = false"
            >
              <option value="50000">50,000 emails/mo</option>
              <option value="100000">100,000 emails/mo</option>
            </select>

            <i
              class="bi arrow-icon"
              [ngClass]="isSelectOpen ? 'bi-chevron-up' : 'bi-chevron-down'"
            >
            </i>
          </div>

          <a
            class="plan-btn text-decoration-none starter-btn mt-3"
            routerLink="/signup" aria-label=" Activate Sign Up" [attr.href]="'/signup'"
          >
            Activate
          </a>
          <div class="plan-volume mt-2">
            <b>Up to {{ starterSelectedVolume | number }} emails/mo</b>
          </div>
          <ul class="plan-features mt-3 text-start">
            <li>APIs, SMTP relay & webhooks</li>
            <li>Secure access via API keys</li>
            <li>Full client libraries</li>
            <li>Template editor included</li>
            <li>
              <b
                >Overage:
                {{ getOverageMailPrice("starter", starterSelectedVolume) }}</b
              >
            </li>
          </ul>
        </div>
      </div>

      <!-- Plus -->
      <div class="col-md-4 col-sm-6">
        <div class="plan-card plus h-100">
          <span class="badge">Most Popular</span>
          <div class="plan-title">Plus</div>
          <p class="plan-desc">
            Ready to scale with up to 1.5 million monthly emails, exclusive of
            GST.
          </p>
          <div class="plan-price">
            {{ getPlanPrice("plus", plusSelectedVolume) }}
          </div>
          <div class="custom-select-wrapper position-relative">
            <select
              [(ngModel)]="plusSelectedVolume"
              class="form-select plan-dropdown"
              (click)="toggleSelect()"
              (blur)="isSelectOpen = false"
            >
              <option value="100000">100,000 emails/mo</option>
              <option value="300000">300,000 emails/mo</option>
              <option value="700000">700,000 emails/mo</option>
            </select>
            <i
              class="bi arrow-icon"
              [ngClass]="isSelectOpen ? 'bi-chevron-up' : 'bi-chevron-down'"
            >
            </i>
          </div>
          <a class="plan-btn plus-btn mt-3 text-decoration-none" aria-label=" Activate Sign Up" routerLink="/signup" [attr.href]="'/signup'">
            Activate
          </a>
          <div class="plan-volume mt-2">
            <b>Up to {{ plusSelectedVolume | number }} emails/mo</b>
          </div>
          <ul class="plan-features mt-3 text-start">
            <li>Full APIs, SMTP relay & webhooks</li>
            <li>Role-based API access</li>
            <li>Advanced template builder</li>
            <li>Dedicated IP available</li>
            <li>
              <b
                >Overage:
                {{ getOverageMailPrice("plus", plusSelectedVolume) }}</b
              >
            </li>
          </ul>
        </div>
      </div>

      <!-- Elite -->
      <div class="col-md-4 col-sm-6">
        <div class="plan-card elite h-100">
          <div class="plan-title">Elite</div>
          <p class="plan-desc">
            Ideal for enterprises sending 5 million+ emails/month.
          </p>
          <!-- <div class="plan-price">{{ getPlanPrice('elite', 'elite') }}</div> -->
          <a class="plan-btn elite-btn mt-3 text-decoration-none" aria-label="Get Support Contact Us" routerLink="/contact" [attr.href]="'/contact'">
            Get Support</a
          ><br /><br /><br />

          <div class="plan-volume mt-2"><b>5,000,000+ emails/month</b></div>
          <ul class="plan-features mt-3 text-start">
            <li>All APIs, SMTP & webhooks</li>
            <li>Advanced key & permission control</li>
            <li>Dedicated IP included</li>
            <li>Real-time deliverability insights</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- clients -->

<!-- <div class="customers-section text-center py-5">
  <h2 class="title mb-4">
    Customers who trust our Transactional Email Services                                                                                                                                                                                                                   
  </h2>

  <div class="container">
    <div class="row justify-content-center g-4">

      <div class="col-10 col-sm-6 col-md-4 col-lg-3"
           *ngFor="let brand of brands">
           
        <div class="brand-card" [ngClass]="brand.type">
          <img [src]="brand.logo" [alt]="brand.name" />
        </div>

      </div>

    </div>
  </div>
</div> -->

<!-- Section 5: 24/7 Support -->
<div class="container-fluid support-section py-5 px-4">
  <div class="row justify-content-center">
    <div class="col-12 text-center mb-4">
      <h2 class="section-title">24/7 Expert Support</h2>
      <p>
        Our team is available around the clock to ensure your emails are always
        delivered without issues.
      </p>
    </div>
  </div>

  <div class="row justify-content-center g-3">
    <div class="col-6 col-md-3 d-flex justify-content-center" *ngFor="let support of supports">

      <a
        [href]="support.link"
        [target]="support.newTab ? '_blank' : '_self'"
        rel="noopener noreferrer"
        class="text-decoration-none"
      >
        <div class="support-card text-center">
          <i class="bi" [ngClass]="support.icon"></i>
          <h6>{{ support.title }}</h6>
        </div>
      </a>
    </div>
  </div>
</div>

<!-- Section 6: Start Sending Reliable Emails -->
<section class="cta-section">
  <div class="container">
    <h2 class="main-title">Start Sending Reliable Emails Today</h2>
    <div class="subtitle">
      Ready to integrate transactional emails into your app or service? MALtech
      helps you get started with setup, templates, and monitoring.
    </div>
    <a routerLink="/contact" rel="noopener noreferrer" aria-label="Contact Us" class="cta-btn" [attr.href]="'/contact'">
      Contact Us 
    </a>
  </div>
</section>



